import { LocalizedPageTitle } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { NewPublicFormWrapper } from '../style';
import { SignUpForm } from './SignUpForm';

export const SignUp = () => (
    <NewPublicFormWrapper vertical>
        <Stack spacing="500" vertical>
            <LocalizedPageTitle textKey={TextKey.CreateYourAccount} />
            <SignUpForm />
        </Stack>
    </NewPublicFormWrapper>
);
